import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_NEW_ORDER_ID: createAsyncMutation('GET_NEW_ORDER_ID'),
    IS_ORDER_ID_VALID: createAsyncMutation('IS_ORDER_ID_VALID'),
    GET_ORDER: createAsyncMutation('GET_ORDER'),
    GET_ORDER_CUSTOMER: createAsyncMutation('GET_ORDER_CUSTOMER'),
}

const order = {
    state: {
    },
    mutations: {
    },
    actions: {
        // GET
        getOrderCustomer(store, customerId) {
            let url = api.order + 'Customer/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_ORDER_CUSTOMER })
        },
        getOrder(store, orderId) {
            let url = api.order + orderId
            return doAsyncGet(store, { url, mutationTypes: types.GET_ORDER })
        },

        validateOrderId(store, payload) {
            let url = api.order + 'OrderID/Validate'
            if (payload) {
                url += '?orderId=' + payload.trim()
            }
            return doAsyncGet(store, { url, mutationTypes: types.IS_ORDER_ID_VALID })
        },

        getNewOrderId(store) {
            let url = api.order + 'OrderID/New'
            return doAsyncGet(store, { url, mutationTypes: types.GET_NEW_ORDER_ID })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default order
